import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { HttpParams } from '@angular/common/http';
import { BudgetHomeService } from 'app/services/budget-home.service';
import { ElementRefService } from 'app/services/element-ref.service';

@Component({
    selector     : 'modern-layout',
    templateUrl  : './modern.component.html',
    styleUrls: ['./modern.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModernLayoutComponent implements OnInit, OnDestroy, AfterViewInit
{
    @ViewChild('footer', { read: ElementRef }) footer: ElementRef;
    @ViewChild('header', { read: ElementRef }) header: ElementRef;

    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    companyTradeName: string = '';
    companyUrlShow: string = '';
    branchAddress: string = '';
    companyEmail: string = '';
    companyPhone: string = '';
    companyPhones: string[] = [];
    companyCellPhone: string = '';
    bitBranchBlog: boolean = false;
    bitCompanyDemo: boolean = false;
    branchFB: string = '';
    branchIG: string = '';
    branchLI: string = '';
    branchTA: string = '';
    branchFooterText: string = '';
    folderImageIsologo: string = './../../../../../assets/images/isologo/';
    nameImageIsologo: string = '';
    pathImageIsologo: string = '';
    errorImageIsologo: boolean = false;
    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService
        ,private _budgethomeService: BudgetHomeService
        ,private elementRefService: ElementRefService
    )
    {
        // let paramsAppend = new HttpParams();
        // paramsAppend = paramsAppend.set("module", "sign-in");
        this._budgethomeService.GetCompanyConfig().subscribe((response) => {
          
          try{
            this.companyTradeName = response.companyconfig.vchCompanyTradeName.toUpperCase();
            this.companyUrlShow = response.companyconfig.vchUrlShow;
          //   this.companyUrlShow = response.companyconfig.vchUrlShow;
          //   this.companyEmail= response.companyconfig.vchEmail;
          //   this.companyPhone = response.companyconfig.vchPhone;
          //   this.companyCellPhone = response.companyconfig.vchCellPhone.replace(/(\s|[&\/\\#,+=()$~%.'":*?<>{}])/g, '');
          this.branchAddress = response.companyconfig.objBranchGeneral.vchAddress;
            this.companyEmail= response.companyconfig.objBranchGeneral.vchEmail;
            this.branchFooterText = response.companyconfig.objBranchGeneral.vchFooterText;
          //   this.companyPhone = response.companyconfig.objBranchGeneral.vchPhone;
            var numeros = response.companyconfig.objBranchGeneral.vchPhone.split('/');
            this.companyPhones = numeros.map(telefono => telefono.trim());
  
          }
          catch{

          }

          try{
            this.companyCellPhone = response.companyconfig.objBranchGeneral.vchWhatsApp.replace(/(\s|[&\/\\#,+=()$~%.'":*?<>{}])/g, '');
          }
          catch{

          }
          
          this.branchFB = response.companyconfig.objBranchGeneral.vchFaceBook;
          this.branchIG = response.companyconfig.objBranchGeneral.vchInstagram;
          this.branchLI = response.companyconfig.objBranchGeneral.vchLinkedIn;
          this.branchTA = response.companyconfig.objBranchGeneral.vchTripAdvisor;

          this.bitCompanyDemo = response.companyconfig.bitDemo;
          this.bitBranchBlog = response.companyconfig.bitBlogActive;
            try{
                var objImgIsologo = response.companyconfig.listImages.find(c => c.bitLightTheme === true && c.bitIsologo === true);
                this.nameImageIsologo = objImgIsologo.vchName;
                 this.pathImageIsologo = this.folderImageIsologo + this.nameImageIsologo;
            }
            catch{
                
            }

        }, (error) => {
            console.log('error:',error.message);
        });

        // this.elementRefService.setElementRefHeader(this.header);
        // this.elementRefService.setElementRefFooter(this.footer);
       
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    ngAfterViewInit(){
        // this.header.nativeElement.focus();
        // this.footer.nativeElement.focus();
        // console.log('this.elementRefService.setElementRefHeader(this.header);',this.header);
            this.elementRefService.setElementRefHeader(this.header);
            this.elementRefService.setElementRefFooter(this.footer);
        
        this.elementRefService.setHeader(this.header);
        this.elementRefService.setFooter(this.footer);
    }
    

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    colorhomebutton(): string {
        const path = this._router.url.split('?')[0]; // Ignora query params
        return (path === '/' || path === '') ? 'primary' : '';
    }
    
    colorcontactbutton():string{
        var href = this._router.url;
        if(href.indexOf('contact') >= 0){
            return 'primary'
        }
        else{
            return ''
        }
    }

    colorpricingbutton():string{
        var href = this._router.url;
        if(href.indexOf('pricing') >= 0){
            return 'primary'
        }
        else{
            return ''
        }
    }

    colorblogbutton():string{
        var href = this._router.url;
        if(href.indexOf('blog') >= 0){
            return 'primary'
        }
        else{
            return ''
        }
    }

    colorsigninbutton():string{
        var href = this._router.url;
        if(href.indexOf('sign-in') >= 0){
            return '#4f46e5'
        }
        else{
            return ''
        }
    }

    colorsigninbuttonlabel():string{
        var href = this._router.url;
        if(href.indexOf('sign-in') >= 0){
            return '#ffffff'
        }
        else{
            return ''
        }
    }

    colorsignupbutton():string{
        var href = this._router.url;
        if(href.indexOf('sign-up') >= 0){
            return '#4f46e5'
        }
        else{
            return ''
        }
    }

    colorsignupbuttonlabel():string{
        var href = this._router.url;
        if(href.indexOf('sign-up') >= 0){
            return '#ffffff'
        }
        else{
            return ''
        }
    }
}
